<template>
    <el-dialog v-model="dialogValue" :show-close="false" :title="title" class="dis-connect-list-dialog" width="300px">
    <el-scrollbar>
      
        <p>{{ content }}</p>
        <div class="btn-box">
          <el-button type="text" @click="dialogValue=false;">No</el-button>
          <el-button type="primary" @click="emit('disConnect')">Confirm</el-button>
        </div>
        
    </el-scrollbar>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { useGlobalStore } from '@/stores/GlobalStore';

const store = useGlobalStore();
const emit = defineEmits(['disConnect']);
const dialogValue = ref(false);//open more social connect
const props = defineProps({
  type: {
    type: String,
    default: ''
  }
});

const title=computed(() => {
  if (props.type === 'google') {
    return 'Remove Google connection from your login method?';
  } else {
    return 'Would you like to disconnect this social account?';
  }
});

const content=computed(() => {
  if (props.type === 'google') {
    return 'If you decide to remove it, you can always add it back later.';
  } else {
    if(store.project === 'sephora'){
      return 'This may affect your ability to collaborate on some opportunities.';
    }else{
      return 'This may affect your ability to collaborate with some brand partners.';
    }
  }
});
//+++++++++++++++++++++
//function
//+++++++++++++++++++++

//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
const open=()=>{
  dialogValue.value = true;
};

const close=()=>{
  dialogValue.value = false;
};

defineExpose({
  open,
  close
});
</script>

<style lang="scss">
.dis-connect-list-dialog{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  header{
    width: 100%;
    text-align: center;
  }

  p{
    width: 100%;
    text-align: center;
  }

  .btn-box{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 8px;
    margin: 16px 0 0;
  }
}

</style>
